/**
 * @fileoverview GET handler for the "/engagement/email_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesId } from "./constants";
import type { EngagementEmailTemplatesIdResult } from "./types";

export const getEngagementEmailTemplatesId = reactQueryFetcherAdapter(
  engagementEmailTemplatesId,
  (signal: AbortSignal, id: string): Promise<EngagementEmailTemplatesIdResult> => {
    return fetch(`/engagement/email_templates/${id}`, "GET", {}, { signal });
  }
);
